<div class="layout-column custom-panel full-width full-height ai-agent-select-panel">
  <ng-container *ngIf="showTriggerRule">
    <div class="layout-row layout-align-start-center ai-agent-select-item"
         (click)="onSelectRuleBased()">
      <span class="flex text-ellipsis font-weight-600" style="font-weight: 600;">{{ 'RECOMMENDATIONS.ROUTE_REFINEMENT' | translate }}</span>
      <div *ngIf="processingAgents['triggerRule']" class="spinner-border" role="status">
        <span class="sr-only"></span>
      </div>
    </div>
  </ng-container>

  <ng-container *ngIf="agents.length > 0; else noAgents">
    <div *ngFor="let agent of agents"
         class="flex-100 layout-row layout-align-start-center ai-agent-select-item"
         (click)="onSelect(agent)">
      <span class="flex text-ellipsis">{{ agent.name }}</span>
      <div *ngIf="processingAgents[agent.id]" class="spinner-border" role="status">
        <span class="sr-only"></span>
      </div>
    </div>
  </ng-container>

  <ng-template #noAgents>
    <div class="layout-row layout-align-start-center ai-agent-select-item">
      <span>{{ 'AI_AGENTS.NO_AGENTS_AVAILABLE' | translate }}</span>
    </div>
  </ng-template>
</div>
